import { render, staticRenderFns } from "./PowerFewShotMain.vue?vue&type=template&id=6e400c10&scoped=true"
import script from "./PowerFewShotMain.vue?vue&type=script&lang=js"
export * from "./PowerFewShotMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e400c10",
  null
  
)

export default component.exports